export type HotelSearchLocationDetails = {
  countryCode?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  placeId?: string;
};

export type HotelSearchFormData = {
  location: string;
  location_details?: HotelSearchLocationDetails;
  checkIn: string;
  checkOut: string;
  guests: number;
};

export const HOTEL_SEARCH_INITIAL_VALUES: HotelSearchFormData = {
  location: '',
  location_details: undefined,
  checkIn: '',
  checkOut: '',
  guests: 1,
};
